export default "__VITE_ASSET__BAvH0v2t__"